import { FaPhone, FaEnvelope } from 'react-icons/fa'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { ProfilePhoto } from 'components/ideal-core-ui'
import { SocialMedia } from 'components/common/SocialMedia'
import s from './ContactDetail.scss'

const ContactDetail = ({ user, toggleModal, isVisible }) => (
  <Modal keyboard={false} backdrop="static" isOpen={isVisible} toggle={toggleModal} size="lg">
    <ModalHeader toggle={toggleModal} className={s.modalHeader}>
      Contact details
    </ModalHeader>
    <ModalBody>
      {(user.firstName || user.lastName) && (
        <div className={s.userMain}>
          <ProfilePhoto src={user.photo} className={s.photo} />
          <div className={s.mainContainer}>
            <p className={s.userName}>{`${user.firstName} ${user.lastName}`}</p>
            <p className={s.userPosition}>{user.title}</p>
            <p className={s.userWebsite}>
              <a href={user.company.link}>{user.company.name}</a>
            </p>
          </div>
        </div>
      )}
      {(user.cellPhone || user.phone || user.email) && (
        <div className={s.secondaryInfo}>
          {user.cellPhone && (
            <p>
              <FaPhone />
              <span>{user.cellPhone} (cell)</span>
            </p>
          )}
          {user.phone && (
            <p>
              <FaPhone />
              <span>{user.phone} (office)</span>
            </p>
          )}
          {user.email && (
            <p>
              <FaEnvelope />
              <span>{user.email}</span>
            </p>
          )}
        </div>
      )}
      <SocialMedia
        facebook={user.facebook}
        twitter={user.twitter}
        linkedin={user.linkedin}
        instagram={user.instagram}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={toggleModal}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
)

export default ContactDetail
